"use strict";
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateGstDetail = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const company_entity_1 = require("./company.entity");
const look_up_entity_1 = require("./look-up.entity");
const state_entity_1 = require("./state.entity");
let StateGstDetail = class StateGstDetail {
    constructor(stateId, gstNumber, gstCategory, company) {
        this.stateId = stateId;
        this.gstNumber = gstNumber;
        this.gstCategory = gstCategory;
        this.company = company;
    }
};
exports.StateGstDetail = StateGstDetail;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], StateGstDetail.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "state_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], StateGstDetail.prototype, "stateId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "gst_number", type: "varchar", length: 15, unique: true }),
    tslib_1.__metadata("design:type", String)
], StateGstDetail.prototype, "gstNumber", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "gst_category_lid", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], StateGstDetail.prototype, "gstCategoryLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "company_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], StateGstDetail.prototype, "companyId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: "created_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], StateGstDetail.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: "updated_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
        onUpdate: "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], StateGstDetail.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.DeleteDateColumn)({
        name: "deleted_at",
        type: "timestamptz",
        nullable: true,
    }),
    tslib_1.__metadata("design:type", Object)
], StateGstDetail.prototype, "deletedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => state_entity_1.State, (state) => state.id, { eager: true }),
    (0, typeorm_1.JoinColumn)({ name: "state_id" }),
    tslib_1.__metadata("design:type", typeof (_d = typeof state_entity_1.State !== "undefined" && state_entity_1.State) === "function" ? _d : Object)
], StateGstDetail.prototype, "state", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => company_entity_1.Company, (company) => company.stateGstDetails, {
        nullable: false,
    }),
    (0, typeorm_1.JoinColumn)({ name: "company_id" }),
    tslib_1.__metadata("design:type", Object)
], StateGstDetail.prototype, "company", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "gst_category_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_e = typeof look_up_entity_1.LookUp !== "undefined" && look_up_entity_1.LookUp) === "function" ? _e : Object)
], StateGstDetail.prototype, "gstCategory", void 0);
exports.StateGstDetail = StateGstDetail = tslib_1.__decorate([
    (0, typeorm_1.Entity)("state_gst_detail"),
    tslib_1.__metadata("design:paramtypes", [Number, String, Object, Object])
], StateGstDetail);
